export default "__VITE_ASSET__Dw3Vm0$R__"